import { Routes, Route } from 'react-router-dom';
import { MobileBlocker, NotFound } from '@commonClient2/components';
import Login from './components/Login';
import SsoLogin from './components/SsoLogin';
import Employee from './Employee/App';
import Manager from './Manager/App';
import Admin from './Admin/App';
import PrivateRoute from './components/PrivateRoute';
import { getPublicConfigs } from './services/api/publicConfigs.service';

/** @type {ApiPublicConfigs.IPublicConfigsPresentationModel} */
const emptyPublicConfigs = {
    appEnvironment: '',
    isMultiLanguage: true,
    hrisUrl: '',
    version: '',
    isWorkplanIntegrationEnabled: false,
};

/** @typedef {keyof ApiPublicConfigs.IPublicConfigsPresentationModel} IPublicConfigsPresentationModelKey */

const setPublicConfigsToStorage = async () => {
    const { data: publicConfigs } = await getPublicConfigs();

    Object.keys(emptyPublicConfigs).forEach((key) => {
        sessionStorage.setItem(key, publicConfigs[key]);
    });
};

const ShiftBiddingRoutes = () => {
    // !isset publicConfigs
    if (!sessionStorage.getItem('hrisUrl')) {
        setPublicConfigsToStorage();
    }

    return (
        <Routes>
            <Route
                path="/login/:target"
                element={<Login />}
            />
            <Route
                path="/sso/:target"
                element={<SsoLogin />}
            />
            <Route
                path="/Employee/*"
                element={(
                    <PrivateRoute
                        redirectTo="/login/Employee"
                        requiredLicense="employee"
                    >
                        <Employee />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/Manager/*"
                element={(
                    <PrivateRoute
                        redirectTo="/login/Manager"
                        requiredLicense="manager"
                    >
                        <MobileBlocker>
                            <Manager />
                        </MobileBlocker>
                    </PrivateRoute>
                )}
            />
            <Route
                path="/Admin/*"
                element={(
                    <PrivateRoute
                        redirectTo="/login/Admin"
                        requiredLicense="manager"
                    >
                        <MobileBlocker>
                            <Admin />
                        </MobileBlocker>
                    </PrivateRoute>
                )}
            />
            <Route
                path="*"
                element={<NotFound />}
            />
        </Routes>
    );
};

export default ShiftBiddingRoutes;
